// extracted by mini-css-extract-plugin
module.exports = {"badgeText":"ProfileCardTextBadge_badgeText__ugOn1","small":"ProfileCardTextBadge_small__j_Yc9"};